import { ConnectButton } from "@rainbow-me/rainbowkit";
import Cookie from "js-cookie";

function Wallet({ className }) {
  return (
    <ConnectButton.Custom>
      {({
        account,
        chain,
        openAccountModal,
        openConnectModal,
        authenticationStatus,
        mounted,
      }) => {
        if (account !== undefined && account.address !== '') {
          Cookie.set("s_wallet", account.address);
        }

        const ready = mounted && authenticationStatus !== "loading";
        const connected =
          ready &&
          account &&
          chain &&
          (!authenticationStatus || authenticationStatus === "authenticated");
        return (
          <div
            {...(!ready && {
              "aria-hidden": true,
              style: {
                opacity: 0,
                pointerEvents: "none",
                userSelect: "none",
              },
            })}
            className={className}
          >
            {(() => {
              if (!connected) {
                return (
                  <button onClick={openConnectModal}>Connect Wallet</button>
                );
              }
              return (
                <button
                  variant="outline"
                  color="secondary"
                  onClick={openAccountModal}
                  radius="xs"
                >
                  {account.displayName}
                </button>
              );
            })()}
          </div>
        );
      }}
    </ConnectButton.Custom>
  );
}

export default Wallet;
